/**
 * @file Renders the header shown on the reset-password form.
 */
import FormHeader from "./FormHeader";

/**
 * Renders the "Forgot your password?" heading and instructions for
 * the reset-password form.
 */
const ResetPasswordHeader = (): JSX.Element => {
  return (
    <FormHeader
      heading="Forgot your password?"
      text="Please enter your email below, and we'll send a verification code to reset your password."
    />
  );
};

export default ResetPasswordHeader;
